import { APP_INITIALIZER, ErrorHandler, isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, Router, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { NebulaCMSModule } from '@scientifica-cms-fe';
import { NebulaConfigModule } from '@scientifica-cms-fe/services/config';
import { FuseMockApiModule } from '@scientifica-cms-fe/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
// import { AngularFireModule } from "@angular/fire/compat";
import { environment } from 'environments/environment';
// import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
// import { AngularFireStorageModule } from "@angular/fire/compat/storage";
// import { PpBreadcrumbsModule } from "pp-breadcrumbs";
import { GoogleRedirectComponent } from './modules/auth/google-redirect/google-redirect.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from '@abacritt/angularx-social-login';
// import * as Sentry from "@sentry/angular";
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './core/transloco/transloco.http-loader';
import { provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { HttpService } from './core/http/http.service';
import { ApiPrefixInterceptor } from './core/http/api-prefix.interceptor';



const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

@NgModule({
    declarations: [
        AppComponent,
        GoogleRedirectComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        NebulaCMSModule,
        NebulaConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,


        // PpBreadcrumbsModule,
        // Layout module of your application
        LayoutModule,
        SocialLoginModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
        // AngularFireModule.initializeApp(environment.firebase),
        // AngularFirestoreModule,
        // AngularFireStorageModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })
    ],
    providers: [
        ApiPrefixInterceptor,
        // {
        //     provide: ErrorHandler,
        //     useValue: Sentry.createErrorHandler(),
        // },
        // {
        //     provide: Sentry.TraceService,
        //     deps: [Router],
        // },
        // {
        //     provide: APP_INITIALIZER,
        //     useFactory: () => () => { },
        //     deps: [Sentry.TraceService],
        //     multi: true,
        // },
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HttpClient,
            useClass: HttpService
        },
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(environment.googleClientId),
                    },
                ],
            } as SocialAuthServiceConfig,
        },
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
